import * as LoginHandler from '@/service/login/loginHandler'

export const toLogin = ({ code, loginType } = {}) => {
  return new Promise((resolve) => {
    const errMessage = 'request fail'
    if (!code) {
      return resolve({
        resp_common: { ret: -100, msg: errMessage },
        data: {
          login_type: loginType,
        },
      })
    }
    if (!(loginType === 'wechat' || loginType === 'qq')) {
      return resolve({
        resp_common: { ret: -100, msg: errMessage },
        data: {
          login_type: loginType,
        },
      })
    }

    let plat = 0
    if (loginType === 'wechat') {
      plat = 189
    } else if (loginType === 'qq') {
      plat = 169
    }

    // 微信登录回调
    // 拿到code去后台获取用户信息
    LoginHandler.login({ login_type: 3, plat_token: code, plat })
      .then(res => resolve(res))
      .catch(() => resolve({
        resp_common: { ret: -100, msg: errMessage },
        data: {
          login_type: loginType,
        },
      }))
  })
}

export default toLogin
